<ziro-breadcrumbs>
  <ziro-breadcrumb-card-item>
    <div
      [innerHTML]="
        !isReadOnly
          ? ('tkey;reports.custom_reports.custom_reports_list.description' | escapeHtml)
          : ('tkey;reports.custom_reports.custom_reports_list.description.read_only' | escapeHtml)
      "
    ></div>
  </ziro-breadcrumb-card-item>
</ziro-breadcrumbs>
<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (!isLoading) {
  <ziro-datatable
    [columns]="columns"
    [rowDataSource]="tableRows"
    [noResultsAlert]="
      isReadOnly
        ? 'tkey;reports.custom_reports.custom_report_list.no_results.read_only'
        : 'tkey;reports.custom_reports.custom_report_list.no_results'
    "
    [dataAutomation]="'custom-report-datatable'"
    [uniqueRowIdentifier]="'id'"
    [class]="'ziro-card'"
  >
    <ng-container filter-content>
      <ziro-datatable-multi-select-filter
        [label]="'tkey;reports.custom_reports.custom_report_list.cucm_server'"
        [items]="serverOptions"
        [matchFn]="isServerMatch"
        [dataAutomation]="'cucm-custom-reports-server-filter'"
        [tableId]="'cucm-custom-reports'"
      ></ziro-datatable-multi-select-filter>
    </ng-container>
  </ziro-datatable>
}
